import React, { useEffect } from "react";
import Top_Heading from "./top_heading/Top_Heading";
import Pink_Btn from "../common/common_btn/pink_btn/Pink_Btn";
import { useNavigate, useParams } from "react-router-dom";
import User_Info from "./user_info/User_Info";
import Order_details_table from "../profile/right_side_content/inner_details_pages/order_details/order_details_table/Order_details_table";
import Payment_Summary from "../profile/right_side_content/inner_details_pages/order_details/payment_summary/Payment_Summary";
import './Track_Order.css'
import { getOrder } from "../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { decodeId } from "../../utils/common";

const Track_Order = () => {
  const navigate = useNavigate();


  const { id } = useParams();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    dispatch(getOrder(decodeId(id)));
  }, [id, dispatch]);


  // console.log({ order });


  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    total_cess: order?.cess_tax,
    no_of_item: Number(order?.no_of_item) - Number(order?.return_on_of_item) - Number(order?.cancel_on_of_item),
    total_selling_price: order?.total_selling_price,
    total_selling_price_gst: order?.total_selling_price_gst,
    total_mrp_gst: order?.total_mrp_gst,
    total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    grand_total: order?.total_amount,
    total_delivery_charges: order?.delivery_charges,
    platform_fee: order?.platform_fee,
    payment_method: order?.Payment_Method?.name,
    total_savings: order?.total_mrp - order?.total_selling_price
  };

  return (
    <section className="TrackOrder">



      <Top_Heading order={order} />

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <User_Info User={order?.User} Address={order?.User_Address} Mode={order?.Payment_Method?.name} />
            <div className="table_div">
              <Order_details_table products={order?.Product_Order_Details || []} />
            </div>
          </div>
          <div className="col-lg-4">
            <Payment_Summary isCheckoutPage data={data} />
          </div>
        </div>

        <div className="btn_holder">
          <Pink_Btn
            btnText="Go to Home"
            onClick={() => {
              navigate("/home");
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Track_Order;
